import { redirect, type RouteObject } from "react-router-dom";

export const askRedoRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Ask Redo" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => false} /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { AskRedoPage } = await import("./ask-redo-page");
          return { Component: AskRedoPage };
        },
      },
      {
        path: "backfills",
        handle: { breadcrumb: "Backfills" },
        async lazy() {
          const { AskRedoBackfillsPage } = await import("./backfills-page");
          return { Component: AskRedoBackfillsPage };
        },
      },
      {
        path: "emergency-mode",
        handle: { breadcrumb: "Emergency mode" },
        async lazy() {
          const { AskRedoEmergencyModePage } =
            await import("./emergency-mode-page");
          return { Component: AskRedoEmergencyModePage };
        },
      },
      {
        path: "product-knowledge",
        loader: () => redirect("/ask-redo?tab=product-knowledge"),
      },
    ],
  },
];
